// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Frame50IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Frame50Icon(props: Frame50IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 30 5"}
      height={"1em"}
      width={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path d={"M15 0l5 5H10l5-5z"} fill={"currentColor"}></path>
    </svg>
  );
}

export default Frame50Icon;
/* prettier-ignore-end */
